import React from 'react';

import phonelineIcon from "../../../../styles/img/NewPackSelector/phoneline.svg";

const Phoneline = () => (
  <div className="phonelineContainer">
    <aside className="phoneline">
      <img src={phonelineIcon} alt="" className="phoneline-icon"/>
      <div className="phoneline-subcontainer">
        <h6 className="phoneline-title">
          Pour toutes vos questions, appelez-nous au
        </h6>
        <a href="tel:+33176350059" className="phoneline-number">
          01 76 35 00 59
        </a>
        <p className="phoneline-subtext">Disponible du Lundi au Vendredi</p>
      </div>
    </aside>
  </div>
);

export default Phoneline;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Phoneline.js